
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup/ram-rampage",
      function () {
        return require("private-next-pages/rims/pickup/ram-rampage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup/ram-rampage"])
      });
    }
  